import { childUsers } from './constant'
import { dayJs } from './dayjs'
import { entries, isEqual, ternary } from './javascript'
import { sidebarMenus } from '../components/layout/sidebar.description'
import { countryLabels } from '../components/userManagement/addressData'

const addressFormat = data => {
  if (data?.pincode || data?.state || data?.city || data?.address) {
    return `${data?.address ? data?.address + ',' : ''} ${
      data?.city ? data?.city + ',' : ''
    } ${data?.state ? data?.state + ',' : ''} ${
      data?.country ? countryLabels[data?.country] + ',' : ''
    } ${data?.pincode ? data?.pincode : ''}`
  } else {
    return '-'
  }
}

const nameParam = roleId =>
  ternary(childUsers.includes(roleId), 'name', 'businessName')

const getAddEditRoles = pathName =>
  sidebarMenus.find(({ key }) => isEqual(key, pathName))?.addEdit || []

const apiParams = ({ params, pageNo }) => {
  let tempParams = ''
  if (pageNo) {
    tempParams += `${pageNo}`
  }
  entries(params).forEach(([key, value], i) => {
    tempParams += `${ternary(isEqual(i, 0), '?', '&')}${key}=${value}`
  })
  return tempParams
}

const dateDaysDifference = (date1, date2) => {
  const startDate = dayJs(date1).startOf('day')
  const endDate = dayJs(date2).startOf('day')
  return endDate.diff(startDate, 'day')
}

export {
  addressFormat,
  nameParam,
  getAddEditRoles,
  apiParams,
  dateDaysDifference,
}
